import { md5 } from "src/common/utils/md5.js";

export const getGravatarUrl = (email: string) => {
	return `https://www.gravatar.com/avatar/${md5(email)}?d=identicon`;
};
